module.exports = __webpack_public_path__ + "img/012.63086446.png";